var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Row, Col } from 'react-grid-system';
import { compose } from 'redux';
import { useParams, useNavigate } from 'react-router-dom';
import injectReducer from '@project/utils/injectReducer';
import { connect } from 'react-redux';
import { selectProfilePageDomain } from './selectors';
import reducer from './reducer';
import { changePassword } from './actions';
import { Helmet } from 'react-helmet';
import { Button } from '@appspotr/ui-kit';
import toast from '../../components/Toast';
import { P } from '../../components/UI-helpers/typography';
import PasswordInput from '../../components/PasswordInput';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import { PageWrapper, PageHeader, PageContent, PageHeaderTitle, } from '../../components/Page';
import { InputWrapper, BackContainer, BackContainerBox, PasswordInputBox, PasswordTextWrapper, PasswordInputWrapper, PasswordContentWrapper, } from './styles';
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirmation: '',
            isPasswordsAreMatching: false,
        };
        _this.handlePasswordChange = function () {
            var _a = _this.state, currentPassword = _a.currentPassword, newPassword = _a.newPassword, newPasswordConfirmation = _a.newPasswordConfirmation;
            if (newPassword.length < 6) {
                toast.error('The new password must contain at least 6 characters.');
                return;
            }
            if (newPassword !== newPasswordConfirmation) {
                toast.error('The new password must match in both fields.');
                return;
            }
            _this.props.changePassword(currentPassword, newPassword);
            _this.setState({
                currentPassword: '',
                newPassword: '',
                newPasswordConfirmation: '',
            });
        };
        return _this;
    }
    ChangePassword.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.loading && !this.props.loading) {
            if (this.props.error !== '') {
                toast.error(this.props.error);
            }
            else {
                toast.success('Changed password!');
            }
        }
    };
    ChangePassword.prototype.render = function () {
        var _this = this;
        var _a = this.state, currentPassword = _a.currentPassword, newPassword = _a.newPassword, newPasswordConfirmation = _a.newPasswordConfirmation, isPasswordsAreMatching = _a.isPasswordsAreMatching;
        var crumbs = [
            { to: "/preference", text: "User Profile" },
            { to: "/preference/changepass", text: "Change Password" },
        ];
        return (_jsxs(PageWrapper, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Change Password" }), _jsx("meta", { name: "description", content: "Change Password" })] }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(PageContent, { children: _jsxs(PasswordContentWrapper, { children: [_jsx(BackContainer, { children: _jsx(BackContainerBox, { children: _jsx(Button, __assign({ type: "outline", onClick: function () { return _this.props.navigate(-1); }, iconLeft: faChevronLeft }, { children: "Back" })) }) }), _jsx(PasswordTextWrapper, { children: _jsx(P, __assign({ black: true, fontSize: 36, bold: true }, { children: "Change Password" })) }), _jsx(PasswordInputWrapper, { children: _jsx(PasswordInputBox, { children: _jsx(InputWrapper, { children: _jsxs(Col, __assign({ lg: 5, className: "bg-white" }, { children: [_jsx(Row, __assign({ justify: "center", className: "py-4 px-12" }, { children: _jsx(PasswordInput, { autoFocus: true, value: currentPassword || '', onChange: function (e) {
                                                            return _this.setState({ currentPassword: e.target.value });
                                                        }, label: "Enter Current Password" }) })), _jsx(Row, __assign({ justify: "center", className: "py-4 px-12" }, { children: _jsx(PasswordInput, { value: newPassword || '', onChange: function (e) {
                                                            return _this.setState({ newPassword: e.target.value });
                                                        }, label: "New Password" }) })), _jsx(Row, __assign({ justify: "center", className: "py-4 px-12" }, { children: _jsx(PasswordInput, { value: newPasswordConfirmation || '', onChange: function (e) {
                                                            return _this.setState({
                                                                newPasswordConfirmation: e.target.value,
                                                                isPasswordsAreMatching: _this.state.newPassword === e.target.value,
                                                            });
                                                        }, label: "Confirm New Password" }) })), _jsx(Row, __assign({ justify: "center", className: "px-12 py-4" }, { children: _jsx(Button, __assign({ disabled: !currentPassword || !isPasswordsAreMatching, type: "primary", onClick: this.handlePasswordChange, style: { width: 200, justifyContent: 'center' } }, { children: "Change Password" })) }))] })) }) }) })] }) })] }));
    };
    return ChangePassword;
}(React.Component));
var mapStateToProps = function (state) { return (__assign({}, selectProfilePageDomain(state))); };
function mapDispatchToProps(dispatch) {
    return {
        changePassword: function (currentPassword, newPassword) {
            dispatch(changePassword(currentPassword, newPassword));
        },
    };
}
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var withReducer = injectReducer({ key: 'profilePage', reducer: reducer });
var ChangePasswordPageWrapper = function (props) {
    var params = useParams();
    var navigate = useNavigate();
    return (_jsx(ConnectedChangePasswordPage, __assign({ params: params, navigate: navigate }, props)));
};
var ConnectedChangePasswordPage = compose(withConnect, withReducer)(ChangePassword);
export default ChangePasswordPageWrapper;
